import React, { useState, useEffect } from 'react';
import { 
  getTeacherSubjects, 
  getTeacherDisplayName,
  getTeacherTitle,
  getTeacherInitials
} from './TeacherDirectoryHelpers';

export const TeacherDirectoryView = ({
  teachers,
  classes,
  classMembers,
  loading,
  error,
  searchTerm,
  setSearchTerm,
  departmentFilter,
  setDepartmentFilter,
  onTeacherSelect
}) => {
  if (loading) {
    return (
      <div className="teacher-directory-view">
        <div className="loading">Loading teachers...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="teacher-directory-view">
        <div className="error">Error loading teachers: {error}</div>
      </div>
    );
  }

  // Filter teachers based on search term and department
  const filteredTeachers = teachers.filter(teacher => {
    const matchesSearch = teacher.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (teacher.subject_specialty && teacher.subject_specialty.toLowerCase().includes(searchTerm.toLowerCase())) ||
                         teacher.department?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDepartment = departmentFilter === 'All' || teacher.department === departmentFilter;
    return matchesSearch && matchesDepartment;
  });

  // Get unique departments for filter
  const departments = ['All', ...new Set(teachers.map(t => t.department))];

  return (
    <div className="teacher-directory-view">
      <div className="view-header">
        <h2>教師列表</h2>
        <div className="search-filters">
          <input
            type="text"
            placeholder="搜尋教師姓名、科目或部門..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <select
            value={departmentFilter}
            onChange={(e) => setDepartmentFilter(e.target.value)}
            className="department-filter"
          >
            {departments.map(dept => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="teachers-grid">
        {filteredTeachers.map(teacher => (
          <div
            key={teacher.id}
            className="teacher-card"
            onClick={() => onTeacherSelect(teacher)}
          >
            <div className="teacher-avatar">
              {teacher.avatar ? (
                <img src={teacher.avatar} alt={teacher.name} />
              ) : (
                <div className="avatar-placeholder">
                  {getTeacherInitials(teacher)}
                </div>
              )}
            </div>
            <div className="teacher-info">
              <h3 className="teacher-name">{getTeacherDisplayName(teacher)}</h3>
              <p className="teacher-title">{getTeacherTitle(teacher)}</p>
              <p className="teacher-department">{teacher.department}</p>
              <p className="teacher-subjects">
                {getTeacherSubjects(teacher).length > 0 ? (
                  <>
                    {getTeacherSubjects(teacher).slice(0, 2).join(', ')}
                    {getTeacherSubjects(teacher).length > 2 && '...'}
                  </>
                ) : (
                  '未指定科目'
                )}
              </p>
              <p className="teacher-email">{teacher.email}</p>
            </div>
            <div className="teacher-status">
              <span className={`status-indicator ${teacher.status === 'active' ? 'active' : 'inactive'}`}>
                {teacher.status === 'active' ? '在職' : '離職'}
              </span>
            </div>
          </div>
        ))}
      </div>

      {filteredTeachers.length === 0 && (
        <div className="no-results">
          <p>沒有找到符合條件的教師</p>
        </div>
      )}
    </div>
  );
};
